export default __webpack_public_path__ + "static/media/home-hero.4fb5c6cc.svg";